// extracted by mini-css-extract-plugin
export default {"cardStyle":"Card_cardStyle__WG+GI","cardImage":"Card_cardImage__U12hM","mediaName":"Card_mediaName__8sJ2n","cardTitle":"Card_cardTitle__8tITE"};